import angular from 'angular';
import angularSanitize from 'angular-sanitize';
import angularUiBootstrap from 'angular-ui-bootstrap';
import angularAnimate from 'angular-animate';
import angularUiRouter from 'angular-ui-router';
import angularLoadingBar from 'angular-loading-bar';

import {AppRoutes} from './routes';

import filters from './filters';
import components from './components';
import views from './views';

import {AppConfig} from './app-config.constant';
import {UserSessionService} from './user-session.service';
import {ProductDataService} from './product-data.service';
import {AppController} from './app.controller';

import angulartics from 'angulartics';
import angularticsGoogleAnalytics from 'angulartics-google-analytics';

export default angular.module('slviz.app', [
    angularSanitize,
    angularUiBootstrap,
    angularAnimate,
    angularUiRouter,
    angularLoadingBar,
    filters,
    components,
    views,

    angulartics,
    angularticsGoogleAnalytics
])
    .config(function (AppConfig, $compileProvider, $logProvider) {
        'ngInject';
        $compileProvider.debugInfoEnabled(AppConfig.debug);
        $logProvider.debugEnabled(AppConfig.debug);
    })
    .config(AppRoutes)
    .config(function ($uibModalProvider) {
        'ngInject';
        $uibModalProvider.options.backdrop = 'static';
    })
    .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
        'ngInject';
        cfpLoadingBarProvider.includeSpinner = false;
    }])
    .config(function ($analyticsProvider) {
        'ngInject';
        // turn off automatic tracking
        $analyticsProvider.virtualPageviews(false);
    })
    .run(function ($log, $rootScope, $analytics) {
        'ngInject';

        // ROUTER EVENTS
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $analytics.pageTrack('/' + toState.name);
        });

    })
    .constant('AppConfig', AppConfig)
    .service('UserSessionService', UserSessionService)
    .service('ProductDataService', ProductDataService)
    .controller('AppController', AppController)
    .name;



// WEBPACK FOOTER //
// ./src/js/app.js